<!-- NHS Nottingham and Nottinghamshire CCG E38000243 -->
<template>
  <b-container fluid>

  </b-container>
</template>

<script>


export default {
  name: "Home",

};
</script>
